import { render } from "./SelectRole.vue?vue&type=template&id=6d3b08d2"
import script from "./SelectRole.vue?vue&type=script&lang=ts"
export * from "./SelectRole.vue?vue&type=script&lang=ts"
script.render = render

export default script